import { UserTags } from "@Safemate/enums/UserTags";
import { AppAction } from "../../../Safemate/Store/types";
import { AlarmFilterEnum } from '../AlarmFilterEnum';
import { OrderFilterEnum } from '../OrderFilterEnum';
import { DeviceListActionTypes } from './actionTypes';
import { PersistedFilters } from "./utils";

export type FilterDeviceType = (devicetypes: number[]) => AppAction<number[]>;
export type FilterCustomer = (customers: number[]) => AppAction<number[]>;
export type FilterAlarm = (alarmfilters: AlarmFilterEnum[]) => AppAction<AlarmFilterEnum[]>;
export type FilterSearch = (search: string) => AppAction<string>;
export type FilterOrder = (order: OrderFilterEnum) => AppAction<OrderFilterEnum>;
export type FilterUserTags = (userTags: UserTags[]) => AppAction<UserTags[]>;
export type ToggleInfo = (device: number) => AppAction<number>;
export type ToggleMaintainFilter = (maintainFilter: boolean) => AppAction<boolean>;
export type ToggleWifiFilter = (wifiFilter: boolean) => AppAction<boolean>;
export type SetFilters = (filters: PersistedFilters) => AppAction<PersistedFilters>;

export const filterDeviceType: FilterDeviceType = (deviceTypes) => ({
  type: DeviceListActionTypes.FILTER_DEVICE_TYPE,
  payload: deviceTypes
})

export const filterCustomer: FilterCustomer = (customers) => ({
  type: DeviceListActionTypes.FILTER_CUSTOMER,
  payload: customers
})

export const filterAlarm: FilterAlarm = (alarmfilters) => ({
  type: DeviceListActionTypes.FILTER_ALARM,
  payload: alarmfilters
})

export const filterSearch: FilterSearch = (search) => ({
  type: DeviceListActionTypes.FILTER_SEARCH,
  payload: search
})

export const filterOrder: FilterOrder = (order) => ({
  type: DeviceListActionTypes.FILTER_ORDER,
  payload: order
})

export const toggleInfo: ToggleInfo = (deviceId) => ({
  type: DeviceListActionTypes.TOGGLE_INFO,
  payload: deviceId
})

export const toggleMaintainFilter: ToggleMaintainFilter = (maintainFilter) => ({
  type: DeviceListActionTypes.TOGGLE_MAINTAIN_FILTER,
  payload: maintainFilter
})

export const filterUserTags: FilterUserTags = (userTags) => ({
  type: DeviceListActionTypes.FILTER_USER_TAGS,
  payload: userTags
})

export const toggleWifiFilter: ToggleWifiFilter = (wifiFilter) => ({
  type: DeviceListActionTypes.TOGGLE_WIFI_FILTER,
  payload: wifiFilter
})

export const setFilters: SetFilters = (filters) => ({
  type: DeviceListActionTypes.SET_FILTERS,
  payload: filters
})